import React from "react";

import { ToolbarContainer } from "./styles";

const UndefinedComponent = () => <div />;

function Toolbar({
  FirstComponent = UndefinedComponent,
  SecondComponent = UndefinedComponent,
  ThirdComponent = UndefinedComponent,
}) {
  return (
    <ToolbarContainer>
      <FirstComponent />
      <SecondComponent />
      <ThirdComponent />
    </ToolbarContainer>
  );
}

export default Toolbar;
